  const SHOP_DATA = [
    {
      id: 1,
      title: 'Books',
      routeName: 'books',
      items: [
        {
          id: 1,
          name: 'Python Crash Course',
          imageUrl: 'https://images.booksense.com/images/022/116/9781801116022.jpg',
          price: 25
        },
        {
          id: 2,
          name: 'MySQL',
          imageUrl: 'https://m.media-amazon.com/images/I/41IO4SmtO9L.jpg',
          price: 18
        },
        {
          id: 3,
          name: 'Moral Compass',
          imageUrl: 'https://images1.penguinrandomhouse.com/cover/9780399179532',
          price: 35
        },
        {
          id: 4,
          name: 'Magonia',
          imageUrl: 'https://m5.paperblog.com/i/124/1246360/why-beautiful-book-covers-are-dangerous-L-tdrBMu.jpeg',
          price: 25
        },
        {
          id: 5,
          name: 'Escaping Exodus',
          imageUrl: 'https://kittymariebookreviewshome.files.wordpress.com/2019/10/escapingexoduspb-2-676x1024.jpg?w=676',
          price: 18
        },
        {
          id: 6,
          name: 'Principles Of Analog Electronics',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/91AJEaq9XcL.jpg',
          price: 14
        },
        {
          id: 7,
          name: 'A Thousand Years To Wait',
          imageUrl: 'https://kittymariebookreviewshome.files.wordpress.com/2019/10/42631411.jpg?w=312',
          price: 18
        },
        {
          id: 8,
          name: 'Relativity',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71oow3Rsy5L.jpg',
          price: 14
        },
        {
          id: 9,
          name: 'The Enigma',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/91BsVzlvTiL.jpg',
          price: 16
        },
        {
          id: 10,
          name: 'Harry Potter and the Philosophers Stone',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/81YOuOGFCJL.jpg',
          price: 16
        },
        {
          id: 11,
          name: 'The Fundamentals Of Microprocessor 8085 & 8086',
          imageUrl: 'https://image1.jdomni.in/product/10072018/1B/C6/B8/DCEF721950D61D52322AA6126F_1531224875858.jpg?fit=around|1024:768',
          price: 16
        },
        {
          id: 12,
          name: 'Buy Shivaji: The Great Maratha Book',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/910WHvI05eL.jpg',
          price: 16
        }
      ]
    },
    {
      id: 2,
      title: 'Graphics material',
      routeName: 'graphics',
      items: [
        {
          id: 1,
          name: 'Solder',
          imageUrl: 'https://www.deltakit.net/wp-content/uploads/2018/05/Soldring-iron-Soldron_25Watt.jpg',
          price: 220
        },
        {
          id: 2,
          name: 'Scale',
          imageUrl: 'https://www.himalayafineart.com/wp-content/uploads/2018/03/Omega-Roll-N-Draw-Scale.jpg',
          price: 280
        },
        {
          id: 3,
          name: 'Black Converse',
          imageUrl: 'https://i.ebayimg.com/images/g/U2QAAOSw6Zhc82TZ/s-l400.jpg',
          price: 110
        },
        {
          id: 4,
          name: 'Drafting Compass',
          imageUrl: 'https://www.alfaplanhold.com/v/vspfiles/photos/2002320-2.jpg?v-cache=1609401859',
          price: 160
        },
        {
          id: 5,
          name: 'Engineering Instrumation Set',
          imageUrl: 'https://e-stationary.in/wp-content/uploads/2019/07/ei1.jpg',
          price: 160
        },
        {
          id: 6,
          name: 'Compass box',
          imageUrl: 'https://www.offimart.com/16934-large_default/hemi-instrument-box-big-size-geometry-box-blue.jpg',
          price: 160
        },
        {
          id: 7,
          name: 'Set Square',
          imageUrl: 'https://5.imimg.com/data5/SELLER/Default/2021/2/AZ/NI/NJ/2525030/engineering-drawing-tool-250x250.JPG',
          price: 190
        },
        {
          id: 8,
          name: 'Calculator',
          imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Casio-fx115ES-5564.jpg/1200px-Casio-fx115ES-5564.jpg',
          price: 200
        }
      ]
    },
    {
      id: 3,
      title: 'E-Books',
      routeName: 'ebook',
      items: [
        {
          id: 1,
          name: 'All The Stars And Teeth',
          imageUrl: 'https://i2.wp.com/jesssbookshelf.com/wp-content/uploads/2020/04/all-the-stars-and-teeth.jpg?resize=323%2C500&ssl=1',
          price: 125
        },
        {
          id: 2,
          name: 'Cristiano Ronaldo: The Biography',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/618HW-NG7+L.jpg',
          price: 90
        },
        {
          id: 3,
          name: 'Machine Learning',
          imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71tk4H0jqpL.jpg',
          price: 90
        },
        {
          id: 4,
          name: 'Artemis Fowl',
          imageUrl: 'https://www.booklistqueen.com/wp-content/uploads/artemis-fowl-eoin-colfer.jpg',
          price: 165
        },
        {
          id: 5,
          name: 'The World Of Ice And Fire',
          imageUrl: 'https://i.imgur.com/IibDqjf_d.webp?maxwidth=760&fidelity=grand',
          price: 185
        },
        {
          id: 6,
          name: 'Object Oriented Programming With C++',
          imageUrl: 'https://m.media-amazon.com/images/I/410budPzfWL.jpg',
          price: 185
        },
        {
          id: 7,
          name: 'Death Note',
          imageUrl: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Death_Note_Vol_1.jpg',
          price: 185
        },
        {
          id: 8,
          name: 'Java Programming',
          imageUrl: 'https://qph.fs.quoracdn.net/main-qimg-f067bd53a994c87dfd41e2fe66323dad',
          price: 185
        }
      ]
    } 
  ]

export default SHOP_DATA